var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1667 0C40.0358 0 0 40.0358 0 89.1667C0 138.297 40.0358 178.333 89.1667 178.333C138.297 178.333 178.333 138.297 178.333 89.1667C178.333 40.0358 138.297 0 89.1667 0ZM131.788 68.6583L81.2308 119.216C79.9825 120.464 78.2883 121.177 76.505 121.177C74.7217 121.177 73.0275 120.464 71.7792 119.216L46.545 93.9817C43.9592 91.3958 43.9592 87.1158 46.545 84.53C49.1308 81.9442 53.4108 81.9442 55.9967 84.53L76.505 105.038L122.337 59.2067C124.922 56.6208 129.202 56.6208 131.788 59.2067C134.374 61.7925 134.374 65.9833 131.788 68.6583Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.4520d67669cc1f0ea67f0bc407dd3d51.svg";
export { ForwardRef as ReactComponent };